import { history } from "helpers";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "./sidebar.module.scss";
import { request } from "service";
import endpoints from "service/endpoints";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { sideBarData } from "../../../constants";

const SideBar = () => {
  let permissionRoleId = localStorage.getItem("permissionRoleId");

  const dispatch = useDispatch();

  const allowedPermissionList = useSelector(
    (state) => state.permission.allowedPermission
  );

  const [sideBarListData, setSideBarListData] = useState([]);
  const [rolePermissions, setRolePermissions] = useState([]);

  useEffect(() => {
    getPermissionsList();
  }, []);

  useEffect(() => {
    if (permissionRoleId) {
      getRoleBasedPermissionsList();
    }
  }, [permissionRoleId]);

  const getPermissionsList = () => {
    request({
      url: endpoints.Endpoints.getPermissions,
      method: endpoints.APIMethods.GET,
      baseUrl: "auth",
    }).then((response) => {
      let list = sideBarData.map((val) => {
        return {
          label: val.label,
          to: val.to,
          img: val.img,
          _id: response.data.data.find(
            (item) => item.permissionName === val.label
          )?._id,
        };
      });
      dispatch({
        type: "ALLOWED_PERMISSIONS",
        payload: sideBarData,
      });
      setSideBarListData([...list]);
    });
  };

  const getRoleBasedPermissionsList = () => {
    request({
      url: endpoints.Endpoints.getRolePermissionUrl + `/${permissionRoleId}`,
      method: endpoints.APIMethods.GET,
      baseUrl: "auth",
    }).then(
      ({
        data: {
          data: { permissions },
        },
      }) => {
        setRolePermissions(permissions);
      }
    );
  };

  useEffect(() => {
    if (rolePermissions.length > 0) {
      finalPermissionFilter();
    }
  }, [rolePermissions, sideBarListData]);

  const finalPermissionFilter = () => {
    let allowedPermissionList = [];
    sideBarListData.map((val) => {
      rolePermissions.includes(val._id) &&
        allowedPermissionList.push({
          ...val,
        });
    });
    dispatch({
      type: "ALLOWED_PERMISSIONS",
      payload: allowedPermissionList,
    });
  };

  const menuListBodySection = (list) => {
    return (
      <div
        className={
          location.pathname.includes(list.to) ||
            (list.children &&
              list.children.some((child) => location.pathname.includes(child)))
            ? styles.activeBar
            : styles.inActiveBar
        }
        onClick={() => {
          history.push(list.to);
          localStorage.setItem("activePage", 1);
        }}
      >
        <span className={styles.dashboardText}>
          <img className="px-2" src={list.img} alt="Icon" />
          <span className="px-2">{list.label}</span>
        </span>
      </div>
    );
  };

  const location = useLocation();

  return (
    <div className={styles.sideBar}>
      {allowedPermissionList?.map((list) => menuListBodySection(list))}
    </div>
  );
};

export default SideBar;
